module.exports = __webpack_public_path__ + "media/images/ArticleType-ff85a9c7c18a5b3e5a3884febe4092f8.png";